import React from 'react'
import MaskedInput from 'react-maskedinput'
import moment from 'moment'
import CustomDateInput from 'live/components/forms/ui/custom-react-datepicker-input'
import DatePicker from 'react-datepicker'
import DateService from 'live/services/date'
import Select from 'react-select'
import i18n from 'live/services/i18n'
import styled, { css } from 'styled-components'
import theme from 'live/services/theme'
import SaveButton from 'live/components/forms/ui/button-save'
import { cloneDeep } from 'lodash'

export const __SOURCE_METADATA__ = 'annotation-kpi-metadata';
export const __SOURCE_ILT__ = 'ilt-manual-edition';
export const __SOURCE_ILT__PLAN_VS_TARGET = 'ilt-plan-target-manual-edition';

export const makeHisotry = (oldEvent, newEvent) => {
    const cloned = cloneDeep(newEvent)
    delete cloned.history

    return {...(oldEvent?.extra?.history ?? {}), [Date.now()]: cloned }
}

export const getWellName = (filter) => {
    try {
        // console.log('filter', filter)
        const filterObj = JSON.parse(filter)
        return !!filterObj?.asset_name_event_type ? filterObj.asset_name_event_type[0] : null
    } catch (error) {
        console.log("Error trying to get wellbore_name from dashboard 'asset_name_event_type' filter", error)
    }

    return null
}

export const getUnixFromDateAndTime = (mom, time) => {
    time = time || ''
    time = time.replace(/_/g, '0')
    const m = moment(`${mom.format('YYYYMMDD')}${time}`, 'YYYYMMDDHH:mm:ss', true)
    return m.valueOf()
}

export const Header = (props) => {
    return (<div className="timeline_notes-header">
        <div className="back" onClick={props.onBack}>
            <i className="fa fa-long-arrow-left" />
            BACK
        </div>
        <div className='title'>{props.title}</div>
    </div>)
}

export const EditingHeader = (props) => {
    return (<div className="timeline_notes-header">
        <div className='title'>{props.title}</div>
    </div>)
}

export const CustomDatePicker = ({ propertyDate, propertyTime, value, label, form, setForm, errors, ...props }) => {
    return (<div className="timeline_date-picker">
        <label htmlFor="timeline-from-date-picker">{i18n(label)}:</label>
        <div className="flex flex-space-between">
            <div className="flex-2 mr-5">
                <DatePicker
                    id="timeline-from-date-picker"
                    customInput={<CustomDateInput invalid={errors[propertyDate]} />}
                    autoComplete="false"
                    selected={form[propertyDate] !== undefined ? form[propertyDate] : value}
                    onChange={(e) => setForm({ ...form, [propertyDate]: e })}
                    maxDate={moment()}
                    dateFormat={DateService.getDateFormat()}
                    placeholderText={DateService.getDateFormat().toLowerCase()}
                    fixedHeight
                    peekNextMonth
                    showYearDropdown
                    showMonthDropdown
                    disabled={props.disabled}
                />
            </div>
            <div className="flex-1 ml-5">
                <MaskedInput
                    className={errors[propertyTime] ? 'error' : ''}
                    type="text"
                    value={
                        form[propertyTime] !== undefined ? form[propertyTime] : value.format('HH:mm:ss')
                    }
                    onChange={(e) => setForm({ ...form, [propertyTime]: e?.target?.value ?? null })}
                    mask="11:11:11"
                    disabled={props.disabled}
                />
            </div>
        </div>
    </div>)
}

export const FromDatePicker = ({ beginValue, form, setForm, errors, ...props }) => {
    return (<div className="timeline_date-picker">
        <label htmlFor="timeline-from-date-picker">{i18n('From')}:</label>
        <div className="flex flex-space-between">
            <div className="flex-2 mr-5">
                <DatePicker
                    id="timeline-from-date-picker"
                    customInput={<CustomDateInput invalid={errors.fromDate} />}
                    autoComplete="false"
                    selected={form.fromDate !== undefined ? form.fromDate : beginValue}
                    onChange={(e) => setForm({ ...form, fromDate: e })}
                    maxDate={moment()}
                    dateFormat={DateService.getDateFormat()}
                    placeholderText={DateService.getDateFormat().toLowerCase()}
                    fixedHeight
                    peekNextMonth
                    showYearDropdown
                    showMonthDropdown
                    disabled={props.disabled}
                />
            </div>
            <div className="flex-1 ml-5">
                <MaskedInput
                    className={errors.fromDate ? 'error' : ''}
                    type="text"
                    value={
                        form.fromTime !== undefined ? form.fromTime : beginValue.format('HH:mm:ss')
                    }
                    onChange={(e) => setForm({ ...form, fromTime: e?.target?.value ?? null })}
                    mask="11:11:11"
                    disabled={props.disabled}
                />
            </div>
        </div>
    </div>)
}

export const ToDatePicker = ({ endValue, form, setForm, errors, ...props }) => {
    return (<div className="timeline_date-picker">
        <label htmlFor="timeline-from-date-picker">{i18n('To')}:</label>
        <div className="flex flex-space-between">
            <div className="flex-2 mr-5">
                <DatePicker
                    id="timeline-from-date-picker"
                    customInput={<CustomDateInput invalid={errors.toDate} />}
                    autoComplete="false"
                    selected={form.toDate !== undefined ? form.toDate : endValue}
                    onChange={(e) => setForm({ ...form, toDate: e })}
                    maxDate={moment()}
                    dateFormat={DateService.getDateFormat()}
                    placeholderText={DateService.getDateFormat().toLowerCase()}
                    fixedHeight
                    peekNextMonth
                    showYearDropdown
                    showMonthDropdown
                    disabled={props.disabled}
                />
            </div>
            <div className="flex-1 ml-5">
                <MaskedInput
                    className={errors.toDate ? 'error' : ''}
                    type="text"
                    value={
                        form.toTime !== undefined ? form.toTime : endValue.format('HH:mm:ss')
                    }
                    onChange={(e) => setForm({ ...form, toTime: e?.target?.value ?? null })}
                    mask="11:11:11"
                    disabled={props.disabled}
                />
            </div>
        </div>
    </div>)
}

export const Selector = ({ label, options, setForm, form, property, required = false }) => {
    return (<div className="timeline__color-picker">
        <Label>{i18n(label)}:</Label>
        <Select options={options}
            required={required}
            onChange={e => setForm({ ...form, [property]: e?.value ?? null })}
            value={form[property]}
        />
    </div>)
}

export const Comment = ({ label, setForm, form, required = false }) => {
    return (<div className="timeline__color-picker">
        <Label>{i18n(label)}:</Label>
        <textarea className={"form-comment"} onChange={(e) => setForm({ ...form, comment: e?.target?.value ?? "" })}>
            {form.comment}
        </textarea>
    </div>)
}

export const Footer = ({ form, onSubmit, disabled, onHide, ...props }) => {
    return (<div className="timeline__form-actions">
        <SaveButton
            className="btn-lg btn-bold mr-5"
            disabled={disabled}
            message={i18n('Note saved successfully')}
            onClick={onSubmit}
        />
        <span>{i18n('or')} </span>

        <a onClick={onHide} className="cancel">
            {' '}
            {i18n('cancel')}
        </a>
    </div>)
}

export const DepthInput = ({ label, property, form, setForm }) => {
    // console.log(property, form)
    return (<DepthContainer>
        <Label>{i18n(label)}:</Label>
        <DepthBody>
            <div>
                <input
                    onMouseDown={e => e.stopPropagation()}
                    type="number"
                    name={property}
                    value={form[property]}
                    onChange={e => {
                        console.log(e, e.target)
                        setForm({ ...form, [property]: e.target.value })
                    }}
                />
            </div>
            <div>
                <Unit>ft</Unit>
            </div>
        </DepthBody>
    </DepthContainer>)
}

export const ContainerBody = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: var(--input-text-color) !important;

    .live-annotation__title {
        background-color: var(--static-gray-900) !important;
        color: white !important;
    }

    input {
        height: 34px !important;
        box-shadow: none;
    }

    .input-group-addon.input-group-addon-right {
        padding-top: 8px;
    }

    .timeline_notes-header {
        display: flex;
        border-radius: 0px !important;
        margin-bottom: 15px !important;

        .title {
            background-color: var(--static-gray-900) !important;
        }

        .back {
            color: #c3e3fa;
            cursor: pointer;
            z-index: 2;

            i {
                margin-right: 5px;
            }
        }

        .title {
            color: white;
            position: absolute;
            left: 0;
            right: 0;
        }
    }

    .timeline_date-picker {
        label {
            color: var(--input-text-color) !important;
        }
    }

    .form-comment {
        min-height: 150px;
    }
`

const Label = styled.span`
    display: flex;
    font-family: ${theme['font-semibold']};
    font-size: 13px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: var(--gray-800);
`

export const WrapperDepth = styled.div`
    display: flex;
    > div {
        flex: 1;
        &:nth-child(1) {
            margin-right: 20px;
        }
    }
`

const DepthContainer = styled.div`
    color: var(--input-text-color);
`

const DepthBody = styled.div`
    height: 34px;
    color: var(--input-text-color);

    input {
        height: 100%;
        border-radius: 0px;
        border: none;
        padding-right: 5px;
        box-shadow: none;
        width: 100%;
    }

    border-radius: 2px;
    border: 1px solid var(--gray-300);

    display: flex;
    > div {
        flex: 1;
    }
    > div:first-child {
        flex: 3;
    }
    > div::nth-child(2) {
        > span {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
`

const Unit = styled.span`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: ${theme['font-semibold']};
    border-left: 1px solid var(--gray-300);
    font-size: 13px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    box-shadow: inset 0 -1px 1px var(--gray-200);
    background-color: var(--gray-100);
`

{/* <div className="timeline__form__message">
                <label htmlFor="timeline-to-date-picker">{i18n('Note text')}:</label>
                <textarea
                    className="form-control"
                    value={form.message}
                    onChange={e => setForm({ ...form, message: e.target.value })} />
            </div> */}
